module.exports = __webpack_public_path__ + "img/Container (4).6c250646.png";